module.exports = __webpack_public_path__ + "static/media/blog-hai-thumb@2x.a302aff1.jpg";